import { render } from "./CoursesHeading.vue?vue&type=template&id=0e3fbbb5&scoped=true"
import script from "./CoursesHeading.vue?vue&type=script&lang=js"
export * from "./CoursesHeading.vue?vue&type=script&lang=js"

import "./CoursesHeading.vue?vue&type=style&index=0&id=0e3fbbb5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e3fbbb5"]])

export default __exports__